import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { formatImageAlt } from "../../../shared/utils/stringUtilities";
import Button from "../../atoms/button/button";

import "./categoryRecommendedHeader.scss"

const CategoryRecommendedHeader = ({
  category,
  description,
  image,
  title,
  tituloBoton,
  type,
}) => {
  const renderDescription = () => {
    switch (type) {
      default:
        return (
          <div className="m-category-recommended__header-picture__description">
            {documentToReactComponents(description.json)}
          </div>
        );
    }
  };

  const renderHeader = () => {
    switch (type) {
      case "Podcast":
        return (
          <div className="m-category-recommended__header-podcast">
            <img src={image.file.url} alt={formatImageAlt(image.file.fileName).replace(/.jpg/, "").replace(/.png/, "")} />
            <div className="m-category-recommended__header-podcast__body">
              <span className="m-category-recommended__header-podcast__category">{category}</span>
              <span className="m-category-recommended__header-podcast__title">{title}</span>
              <div className="m-category-recommended__header-podcast__description">
                {documentToReactComponents(description.json)}
              </div>
            </div>
          </div>
        );
      case "Contenido editorial":
        return (
          <div className="m-category-recommended__header-book">
            <img src={image.file.url} alt={formatImageAlt(image.file.fileName).replace(/.jpg/, "").replace(/.png/, "")} />
            <div className="m-category-recommended__header-book__body">
              <span className="m-category-recommended__header-book__category">{category}</span>
              <span className="m-category-recommended__header-book__title">{title}</span>
              <div className="m-category-recommended__header-book__description">
                {description && documentToReactComponents(description.json)}
              </div>
              <div className="m-category-recommended__header-book__button">
                <Button
                  type="link"
                  text={tituloBoton}
                  isDisabled={false}
                  classname="primary"
                />
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="m-category-recommended__header-picture">
            <img src={image.file.url} alt={formatImageAlt(image.file.fileName).replace(/.jpg/, "").replace(/.png/, "")} />
            <div className="m-category-recommended__header-picture__body">
              <span className="m-category-recommended__header-picture__category">{category}</span>
              <span className="m-category-recommended__header-picture__title">{title}</span>
              {description ? renderDescription() : null}
            </div>
          </div>
        );
    }
  };

  return renderHeader();
};

export default CategoryRecommendedHeader;
